import { FiscalNoteModel } from "../../../../../../domain/models/fiscal-note";
import { makeRemoteFiscalNote } from "../../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

const cancelRecurrenceFiscalNote = async (noteId: number): Promise<FiscalNoteModel> =>
  makeRemoteFiscalNote().cancelRecurrence(noteId);

export default cancelRecurrenceFiscalNote;
